import * as Sentry from '@sentry/react';

import { RUNTIME_ENV } from '../envConfig';

// Initialize Sentry with the default integrations, but defer the heavy ones
// (browserTracing + replay) to idle time below. The default integrations are
// what give events the request URL (httpContextIntegration), the breadcrumb
// trail (breadcrumbsIntegration), global handlers, dedupe, and linked-error
// causes — they were all absent while `integrations` was `[]`, leaving prod
// events with no URL, no breadcrumbs, and no usable context.
Sentry.init({
  dsn: 'https://60645459cb8720a1cd645aac397cd5c2@o322377.ingest.us.sentry.io/4509286103580672',
  sendDefaultPii: true,
  integrations: Sentry.getDefaultIntegrations({}),
  environment: RUNTIME_ENV,
  // Git short SHA injected at build time (see rspack.config.js). Pins events to
  // the uploaded sourcemap release so minified prod stacks de-minify.
  release: process.env.SENTRY_RELEASE,
  beforeSend: event => {
    if (RUNTIME_ENV !== 'localdev') {
      return event;
    }
    return null;
  },
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

if (typeof window !== 'undefined') {
  const loadIntegrations = () => {
    Sentry.addIntegration(Sentry.browserTracingIntegration());
    Sentry.addIntegration(Sentry.replayIntegration());
  };

  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(loadIntegrations);
  } else {
    setTimeout(loadIntegrations, 0);
  }
}

export const SentryErrorBoundary = Sentry.ErrorBoundary;
